import reduceToSingleValidAlertToUser from "@/model/errorAlerts.js";
import AlertsService from "@/services/DeviceHealthService.js";
import deviceTypes from "@/constants/deviceTypes";
import { cloneDeep } from "lodash";
export default {
  namespaced: true,
  state: function() {
    return {
      alertsFilter: {
        POND: [],
        ALERTS: [],
      },
      alerts: [],
      totalDeviceWiseAlertsCount: {},
    };
  },
  getters: {
    getAlertsFilter: (state) => state.alertsFilter,
    getAllValidErrorAlerts: function(state, getters) {
      const errorAlerts = {
        POND_MOTHER: [],
        POND_GUARD: [],
        SHRIMP_TALK: [],
      };
      state.alerts.forEach((pond) => {
        [
          {
            device_type: deviceTypes.POND_MOTHER.key,
            bknd_key: "pond_mother_alerts",
          },
          {
            device_type: deviceTypes.POND_GUARD.key,
            bknd_key: "pond_guard_alerts",
          },
          {
            device_type: deviceTypes.SHRIMP_TALK.key,
            bknd_key: "shrimp_talk_alerts",
          },
        ].reduce((accAllDeviceAlerts, iterObj) => {
          const key = iterObj.bknd_key;
          const device_type = iterObj.device_type;
          if (pond[key] && pond[key].length !== 0) {
            const arrAlerts = pond[key].reduce((accDeviceAlerts, alert) => {
              const arrErrorCodes = reduceToSingleValidAlertToUser(
                alert.errors_data,
                "error_code",
                device_type
              );
              const arrAlerts = arrErrorCodes.map((errorCode) => {
                errorCode.pond_name = pond.title;
                errorCode.pond_id = pond._id;
                errorCode.device_type = device_type;
                errorCode.device_code = alert.device_code;
                errorCode.device_title = alert.device_title;
                errorCode.device_id = alert.device_id;
                return errorCode;
              });
              if (arrAlerts.length > 0) {
                accDeviceAlerts.push(...arrAlerts);
              }
              return accDeviceAlerts;
            }, []);
            accAllDeviceAlerts[device_type].push(...arrAlerts);
          }
          return accAllDeviceAlerts;
        }, errorAlerts);
      });
      return errorAlerts;
    },
    getTotalErrorAlertCountByDeviceType: function(state, getters) {
      const allValidErrorAlerts = getters.getAllValidErrorAlerts;
      return ["POND_MOTHER", "POND_GUARD", "SHRIMP_TALK"].reduce(
        (acc, curr) => {
          acc[curr] = allValidErrorAlerts[curr].length;
          return acc;
        },
        {}
      );
    },
    getValidAlertsFilterByPondIds: function(state, getters) {
      const errorAlerts = {
        POND_MOTHER: [],
        POND_GUARD: [],
        SHRIMP_TALK: [],
      };
      const arrAlerts = getters.getAlertsFilterByPondIds;
      arrAlerts.forEach((pond) => {
        if (!pond) return;
        [
          {
            device_type: deviceTypes.POND_MOTHER.key,
            bknd_key: "pond_mother_alerts",
          },
          {
            device_type: deviceTypes.POND_GUARD.key,
            bknd_key: "pond_guard_alerts",
          },
          {
            device_type: deviceTypes.SHRIMP_TALK.key,
            bknd_key: "shrimp_talk_alerts",
          },
        ].reduce((accAllDeviceAlerts, iterObj) => {
          const key = iterObj.bknd_key;
          const device_type = iterObj.device_type;
          if (pond[key] && pond[key].length !== 0) {
            const arrAlerts = pond[key].reduce((accDeviceAlerts, alert) => {
              const arrErrorCodes = reduceToSingleValidAlertToUser(
                alert.errors_data,
                "error_code",
                device_type
              );
              const arrAlerts = arrErrorCodes.map((errorCode) => {
                errorCode.pond_name = pond.title;
                errorCode.pond_id = pond._id;
                errorCode.device_type = device_type;
                errorCode.device_code = alert.device_code;
                errorCode.device_title = alert.device_title;
                errorCode.device_id = alert.device_id;
                return errorCode;
              });
              if (arrAlerts.length > 0) {
                accDeviceAlerts.push(...arrAlerts);
              }
              return accDeviceAlerts;
            }, []);
            accAllDeviceAlerts[device_type].push(...arrAlerts);
          }
          return accAllDeviceAlerts;
        }, errorAlerts);
      });
      return errorAlerts;
    },
    getPondAlertsToPondIdMap: function(state) {
      return state.alerts.reduce((acc, curr) => {
        acc[curr._id] = curr;
        return acc;
      }, {});
    },
    getAlertsFilterByPondIds(state, getters) {
      const pondIds = state.alertsFilter.POND;
      let arrAlerts = [];
      if (pondIds.length > 0) {
        arrAlerts = pondIds.map(
          (pondId) => getters.getPondAlertsToPondIdMap[pondId]
        );
      }
      return arrAlerts;
    },
    getFilterAlertGroupByDeviceType(state) {
      const groupAlertByDeviceType = state.alertsFilter.ALERTS.reduce(
        (deviceFitlerAlerts, { device_type, alert_type }) => {
          deviceFitlerAlerts[device_type].add(alert_type);
          return deviceFitlerAlerts;
        },
        {
          POND_MOTHER: new Set(),
          POND_GUARD: new Set(),
          SHRIMP_TALK: new Set(),
        }
      );
      for (const key in groupAlertByDeviceType) {
        groupAlertByDeviceType[key] = [...groupAlertByDeviceType[key]];
      }
      return groupAlertByDeviceType;
    },
    getFilterTableData: function(state, getters) {
      const deviceWiseAlerts = getters.getValidAlertsFilterByPondIds;
      const groupAlertByDeviceType = state.alertsFilter.ALERTS.reduce(
        (deviceFitlerAlerts, { device_type, alert_type }) => {
          deviceFitlerAlerts[device_type].add(alert_type);
          return deviceFitlerAlerts;
        },
        {
          POND_MOTHER: new Set(),
          POND_GUARD: new Set(),
          SHRIMP_TALK: new Set(),
        }
      );
      let arrAlerts = Object.keys(groupAlertByDeviceType).map((key) => {
        const arrAlerts = [...groupAlertByDeviceType[key]];
        return deviceWiseAlerts[key].filter((x) =>
          arrAlerts.includes(x.error_code)
        );
      });
      arrAlerts = arrAlerts.flat(1);
      return arrAlerts;
    },
    getTotalDeviceWiseAlertsCount: function(state) {
      return state.totalDeviceWiseAlertsCount;
    },
    getTotalPondsWithAlerts(state, getters, rootState, rootGetters) {
      const location = rootGetters["user/getCurrUserLocation"];
      const alerts = state.alerts;
      const totalPonds = alerts.filter(
        ({ location_id }) => location_id === location._id
      );
      const noAlertPonds = alerts.filter(
        ({
          pond_mother_alerts,
          shrimp_talk_alerts,
          pond_guard_alerts,
          location_id,
        }) => {
          return (
            !pond_mother_alerts &
            !shrimp_talk_alerts &
            !pond_guard_alerts &
            (location_id === location._id)
          );
        }
      );
      return totalPonds.length - noAlertPonds.length;
    },
    getFilterPondIdsAlertTypesByDeviceType(state, getters) {
      const mapFEToBKDevices = {
        POND_MOTHER: "pond_mothers",
        POND_GUARD: "pond_guards",
        SHRIMP_TALK: "shrimp_talks",
      };
      const totalAlertsCount = getters.getTotalErrorAlertCountByDeviceType;
      return [
        {
          key: "PM",
          device_type: "POND_MOTHER",
          name: "PondMother",
        },
        {
          key: "PG",
          device_type: "POND_GUARD",
          name: "PondGuard",
        },
        {
          key: "ST",
          device_type: "SHRIMP_TALK",
          name: "ShrimpTalk",
        },
      ].reduce((acc, { key, name, device_type }) => {
        let deviceAlerts = cloneDeep(
          getters.getValidAlertsFilterByPondIds[device_type]
        );
        deviceAlerts = deviceAlerts.sort(
          (a, b) => a.user_priority - b.user_priority
        );
        const alertsForADevice = deviceAlerts.reduce(
          (acc, { error_code, device_id, user_priority }) => {
            if (!acc.types[error_code]) {
              acc.types[error_code] = {
                count: 0,
                error_code: error_code,
                user_priority: user_priority,
                arr_device_ids: [],
              };
            }
            acc.types[error_code].count++;
            acc.types[error_code].arr_device_ids.push(device_id);
            return acc;
          },
          {
            types: {},
            total_devices:
              getters.getTotalDeviceWiseAlertsCount[
                mapFEToBKDevices[device_type]
              ],
          }
        );
        const fitlerGroupAlerts = getters.getFilterAlertGroupByDeviceType;
        const deviceFilterAlerts = fitlerGroupAlerts[device_type];
        const total_devices_with_alerts = new Set();
        for (const eachAlertType in alertsForADevice.types) {
          if (!deviceFilterAlerts.includes(eachAlertType)) {
            delete alertsForADevice.types[eachAlertType];
          } else {
            alertsForADevice.types[eachAlertType].arr_device_ids.forEach(
              (deviceId) => {
                total_devices_with_alerts.add(deviceId);
              }
            );
          }
        }
        acc[device_type] = alertsForADevice;
        acc[device_type].total_devices_with_alerts = [
          ...total_devices_with_alerts,
        ].length;
        acc[device_type].count = totalAlertsCount[device_type];
        acc[device_type].device_type = device_type;
        acc[device_type].name = name;
        acc[device_type].key = key;
        return acc;
      }, {});
    },
    getAllPondsAlertTypesByDeviceType(state, getters) {
      const mapFEToBKDevices = {
        POND_MOTHER: "pond_mothers",
        POND_GUARD: "pond_guards",
        SHRIMP_TALK: "shrimp_talks",
      };
      const totalAlertsCount = getters.getTotalErrorAlertCountByDeviceType;
      return [
        {
          key: "PM",
          device_type: "POND_MOTHER",
          name: "PondMother",
        },
        {
          key: "PG",
          device_type: "POND_GUARD",
          name: "PondGuard",
        },
        {
          key: "ST",
          device_type: "SHRIMP_TALK",
          name: "ShrimpTalk",
        },
      ].reduce((acc, { key, name, device_type }) => {
        let deviceAlerts = cloneDeep(
          getters.getAllValidErrorAlerts[device_type]
        );
        deviceAlerts = deviceAlerts.sort(
          (a, b) => a.user_priority - b.user_priority
        );
        const alertsForADevice = deviceAlerts.reduce(
          (acc, { error_code, device_id, user_priority }) => {
            if (!acc.types[error_code]) {
              acc.types[error_code] = {
                count: 0,
                error_code: error_code,
                user_priority: user_priority,
              };
            }
            if (!acc.unique_ids.has(device_id)) {
              acc.unique_ids.add(device_id);
              acc.total_devices_with_alerts++;
            }
            acc.types[error_code].count++;
            return acc;
          },
          {
            types: {},
            unique_ids: new Set(),
            total_devices_with_alerts: 0,
            total_devices:
              getters.getTotalDeviceWiseAlertsCount[
                mapFEToBKDevices[device_type]
              ],
          }
        );
        acc[device_type] = alertsForADevice;
        acc[device_type].count = totalAlertsCount[device_type];
        acc[device_type].device_type = device_type;
        acc[device_type].name = name;
        acc[device_type].key = key;
        return acc;
      }, {});
    },
    getAllPondsWithTitle(state) {
      return state.alerts.map((x) => ({ _id: x._id, title: x.title }));
    },
    getPondsHavingAlerts(state, getters) {
      return Object.values(
        Object.values(getters.getAllValidErrorAlerts)
          .flat(1)
          .reduce((acc, x) => {
            acc[x.pond_id] = { _id: x.pond_id, title: x.pond_name };
            return acc;
          }, {})
      );
    },
    getInitialAllAvailableAlertFilters(state, getters) {
      const allAlertsByDeviceType = getters.getAllPondsAlertTypesByDeviceType;
      const alertFilters = [];
      for (const device_type in allAlertsByDeviceType) {
        alertFilters.push(
          Object.keys(allAlertsByDeviceType[device_type].types).map(
            (alertType) => {
              return {
                device_type,
                alert_type: alertType,
              };
            }
          )
        );
      }
      return alertFilters.flat(1);
    },
  },
  mutations: {
    SET_ALERT_FILTER_SELECTION(state, data) {
      state.alertsFilter[data.filter_type] = data.filters;
      state.alertsFilter = Object.assign({}, state.alertsFilter);
    },
    SET_ALL_ALERTS(state, payload) {
      state.alerts = payload;
    },
    SET_TOTAL_DEVICES_COUNT(state, totalDeviceCount) {
      state.totalDeviceWiseAlertsCount = totalDeviceCount;
    },
  },
  actions: {
    changeAlertsFilterSelection: async (context, data) => {
      context.commit("SET_ALERT_FILTER_SELECTION", data);
    },
    fetchAllAlerts: async function(context, data) {
      const location = context.rootGetters["user/getCurrUserLocation"];
      const response = await AlertsService.fetchPondAlerts({
        location_id: location._id,
      });
      context.commit("SET_ALL_ALERTS", response.data.ponds);
      const pondIds = context.getters.getPondsHavingAlerts.map((x) => x._id);
      context.commit("SET_ALERT_FILTER_SELECTION", {
        filter_type: "POND",
        filters: pondIds,
      });
      const availableFilters =
        context.getters.getInitialAllAvailableAlertFilters;
      context.commit("SET_ALERT_FILTER_SELECTION", {
        filter_type: "ALERTS",
        filters: availableFilters,
      });
      context.commit("SET_TOTAL_DEVICES_COUNT", response.data.total_devices);
    },
  },
};
